module.exports = __webpack_public_path__ + "static/img/B6.b2aa9f53.png";